import { peopleTypes } from '@/reports/types';
import { Stack, Text, useTheme } from '@/theme/index';
import { getDatesAttended, titleize } from '@/utils/index';

interface MobileEducationRowProps {
  /** The Education information. */
  education: peopleTypes.Education;
}

/**
 * Reusable component that displays a text row with label and value.
 */
function TextRow({ label, value }: { label: string; value: string }) {
  const theme = useTheme();

  return (
    <Stack direction="row" spacing={2}>
      <Text fontWeight={theme.typography.fontWeightBold} width={114}>
        {label}
      </Text>
      <Text width={146}>{value}</Text>
    </Stack>
  );
}

/**
 * Represents an education row in the mobile view.
 */
export function MobileEducationRow({ education }: MobileEducationRowProps) {
  const theme = useTheme();

  const stackStyles = {
    marginTop: theme.spacing(2.5),
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
    paddingBottom: theme.spacing(2),
  };

  return (
    <Stack spacing={2} sx={stackStyles}>
      <TextRow
        label="School"
        value={titleize(education.school || '', { lowercase: true }) || '-'}
      />
      <TextRow label="Degree" value={education.degree || '-'} />
      <TextRow
        label="Dates Attended"
        value={getDatesAttended(education, true) || '-'}
      />
    </Stack>
  );
}
